// extracted by mini-css-extract-plugin
module.exports = {"navigationBar":"NavigationBottomBar_navigationBar__2kz_8","container":"NavigationBottomBar_container__2jlTn","column":"NavigationBottomBar_column__yHTPy"};